import { Injectable } from '@angular/core';
import { ManagementHttpClient } from './management-http-client';
import { Observable } from 'rxjs';
import { QueryStringBuilder } from '@bayclubs/utils';
import { GetMembersQuery, MembersModel } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root'
})
export class MemberApiService {
    constructor(private http: ManagementHttpClient) {}

    public get(query: GetMembersQuery): Observable<MembersModel> {
        const url = `members?` + QueryStringBuilder.buildParametersFromSearch(query).toString();
        return this.http.get<MembersModel>(url, false);
    }
}
